<form [formGroup]="resetForm" (ngSubmit)="onSubmitForm()" class="[ stack ]" data-cy="request-password-form">
  <dcr-text-field type="email" formControlName="email" label="E-mailadres" data-cy="input-request-password-form-email"></dcr-text-field>

  <div class="[ stack stack-space-3xs ]">
    <dcr-inline-button
      class="[ flex self-end ]"
      label="Ik weet het weer!"
      (click)="onCancel()"
      data-cy="btn-request-password-form-cancel"
    ></dcr-inline-button>
  </div>
  <div class="[ flex justify-between ]">
    <dcr-filled-button
      label="Stuur een reset e-mail"
      type="submit"
      [disabled]="!resetForm.valid"
      data-cy="btn-request-password-form-reset"
    ></dcr-filled-button>
    <dcr-inline-button
      routerLink="/registratie"
      label="Registreer als nieuwe leerling"
      *ngIf="showRegister"
      data-cy="btn-request-password-form-register"
    ></dcr-inline-button>
  </div>
</form>
